;(function () {
  'use strict'

  var config = window.__CHICCHOK_OPENAI_ADS_CONFIG__
  if (!config || !config.pixelId || typeof window.oaiq !== 'function') return
  if (config.shopDomain !== 'kgty3d-xi.myshopify.com' || !/^(www\.)?chicchok\.net$/.test(window.location.hostname)) return
  if (window.__CHICCHOK_NET_OPENAI_LOADED__) return
  window.__CHICCHOK_NET_OPENAI_LOADED__ = true

  var state = {
    consentAllowed: false,
    measurementReady: false,
    userInitialized: false,
    initialEventsSent: false,
    attributionSignature: '',
    attributionSync: null,
    attributionClear: Promise.resolve(),
    consentEpoch: 0,
    consentCleared: false,
    checkoutPending: null,
    checkoutSent: false,
    cartSnapshotReady: false,
    cart: null,
    cartQuantities: {},
    recentAdds: {},
    ignoreLandingTouch: false,
  }

  var attributionStorageKey = 'chicchok_net_openai_attribution_v3'
  var attributionLifetime = 30 * 24 * 60 * 60 * 1000

  function storedAttribution() {
    try { return JSON.parse(window.localStorage.getItem(attributionStorageKey) || '{}') || {} }
    catch (error) { return {} }
  }

  function saveAttribution(value) {
    try { window.localStorage.setItem(attributionStorageKey, JSON.stringify(value)) }
    catch (error) { /* Cart attributes remain the fallback when storage is unavailable. */ }
  }

  function attributionAttributes(existing) {
    var saved = storedAttribution()
    var now = Date.now()
    var params = new URLSearchParams(window.location.search)
    var fromUrl = state.ignoreLandingTouch ? '' : validReference(params.get('oppref'))
    var source = nonEmptyText(params.get('utm_source')).toLowerCase()
    var openaiUtm = !state.ignoreLandingTouch && /^(openai|chatgpt)$/.test(source)
    if (existing.openai_shop_domain !== config.shopDomain) existing = {}
    var prior = Number(existing.openai_attribution_expires_at) > Number(saved.openai_attribution_expires_at || 0)
      ? existing : saved
    var expiry = Number(prior.openai_attribution_expires_at || 0)
    var fresh = expiry > now && expiry <= now + attributionLifetime
    var expired = saved.expired === true || (expiry > 0 && !fresh)
    var newUtmTouch = openaiUtm && ((!expiry && !expired) || source !== (prior.openai_utm_source || '') ||
      ['medium', 'campaign', 'content', 'term'].some(function (key) {
        return nonEmptyText(params.get('utm_' + key)).slice(0, 200) !== (prior['openai_utm_' + key] || '')
      }))
    // A new UTM-only landing has no click reference. Never attach its campaign
    // to the previous landing's __oppref cookie or stored cart reference.
    if (newUtmTouch && !fromUrl) clearReferenceCookies(['__oppref'])
    var incoming = fromUrl || (expired || newUtmTouch ? '' : currentOppref())
    // Repeated synchronization of the same landing must not extend attribution.
    var newTouch = Boolean((fromUrl && fromUrl !== prior.openai_oppref) ||
      newUtmTouch ||
      (incoming && incoming !== prior.openai_oppref))
    var keep = fresh && !newTouch ? prior : {}
    var attributes = {
      openai_oppref: incoming || validReference(keep.openai_oppref),
      openai_obref: currentObref() || validReference(keep.openai_obref),
      openai_landing_path: validLandingPath(keep.openai_landing_path) || window.location.pathname || '/',
      openai_measurement_consent: 'granted',
      openai_shop_domain: config.shopDomain,
      openai_consent_expires_at: String(now + attributionLifetime),
      openai_attribution_expires_at: String(newTouch || (!expiry && !expired) ? now + attributionLifetime : expiry || now),
      openai_utm_source: openaiUtm ? source : nonEmptyText(keep.openai_utm_source),
    }
    ;['medium', 'campaign', 'content', 'term'].forEach(function (key) {
      attributes['openai_utm_' + key] = (openaiUtm ? nonEmptyText(params.get('utm_' + key)) : nonEmptyText(keep['openai_utm_' + key])).slice(0, 200)
    })
    if (expired && !newTouch) {
      state.ignoreLandingTouch = true
      clearReferenceCookies(['__oppref', '__obref'])
      // The SDK also reads landing URLs. Remove only expired measurement refs,
      // keeping all unrelated query parameters and the page navigation intact.
      if (fromUrl) clearLandingReference()
      attributes.openai_oppref = ''
      attributes.openai_obref = ''
      attributes.openai_landing_path = ''
      ;['source', 'medium', 'campaign', 'content', 'term'].forEach(function (key) { attributes['openai_utm_' + key] = '' })
      saveAttribution({ expired: true })
    } else {
      saveAttribution(attributes)
    }
    return attributes
  }

  // Both requests have a finite deadline; analytics must never trap a checkout.
  function cartFetch(url, options) {
    var controller = new AbortController()
    var timer = window.setTimeout(function () { controller.abort() }, 1800)
    return fetch(url, Object.assign({}, options, { signal: controller.signal }))
      .finally(function () { window.clearTimeout(timer) })
  }

  function integer(value) {
    var number = Number(value)
    return Number.isFinite(number) ? Math.round(number) : 0
  }

  function text(value) {
    return value == null ? '' : String(value)
  }

  function nonEmptyText(value) {
    return text(value).trim()
  }

  function currencyCode(value) {
    var candidate = nonEmptyText(value).toUpperCase()
    return /^[A-Z]{3}$/.test(candidate) ? candidate : ''
  }

  function sha256Hash(value) {
    var candidate = nonEmptyText(value).toLowerCase()
    return /^[a-f0-9]{64}$/.test(candidate) ? candidate : ''
  }

  function pixelUser() {
    var configured = config.user && typeof config.user === 'object' ? config.user : null
    if (!configured) return null

    var user = {}
    var email = sha256Hash(configured.email_sha256)
    var externalId = sha256Hash(configured.external_id_sha256)
    if (email) user.email_sha256 = email
    if (externalId) user.external_id_sha256 = externalId
    return Object.keys(user).length > 0 ? user : null
  }

  function cleanContent(item, fallbackCurrency) {
    if (!item || typeof item !== 'object') return null

    var content = {}
    var id = nonEmptyText(item.id || item.variant_id || item.key || item.sku)
    var name = nonEmptyText(item.name || item.product_title || item.title)
    var contentType = nonEmptyText(item.content_type)
    var quantity = Number(item.quantity)
    var amountSource = item.amount
    if (amountSource == null) amountSource = item.final_price
    if (amountSource == null) amountSource = item.price
    var amount = Number(amountSource)
    var itemCurrency = currencyCode(item.currency || fallbackCurrency)

    if (id) content.id = id
    if (name) content.name = name
    if (contentType) content.content_type = contentType
    if (Number.isFinite(quantity) && quantity > 0) content.quantity = Math.round(quantity)
    if (Number.isFinite(amount) && amount >= 0 && itemCurrency) {
      content.amount = Math.round(amount)
      content.currency = itemCurrency
    }

    return id || name ? content : null
  }

  function cleanContentsData(data) {
    if (!data || data.type !== 'contents') return null

    var cleaned = { type: 'contents' }
    var eventCurrency = currencyCode(data.currency || config.currency)
    var amount = Number(data.amount)
    if (Number.isFinite(amount) && amount >= 0 && eventCurrency) {
      cleaned.amount = Math.round(amount)
      cleaned.currency = eventCurrency
    }

    if (Array.isArray(data.contents)) {
      var contents = data.contents
        .slice(0, 100)
        .map(function (item) { return cleanContent(item, eventCurrency) })
        .filter(Boolean)
      if (contents.length > 0) cleaned.contents = contents
    }
    return cleaned
  }

  function itemName(item) {
    return text(item.product_title || item.title || item.name)
  }

  function variantKey(item) {
    return text(item && (item.id || item.variant_id || item.key || item.sku))
  }

  function cartItem(item) {
    return {
      id: variantKey(item),
      name: itemName(item),
      content_type: 'product',
      quantity: Math.max(1, integer(item.quantity) || 1),
      amount: integer(item.final_price == null ? item.price : item.final_price),
      currency: item.currency || (state.cart && state.cart.currency) || config.currency,
    }
  }

  function cartQuantities(cart) {
    var quantities = {}
    var items = cart && Array.isArray(cart.items) ? cart.items : []
    items.forEach(function (item) {
      var key = variantKey(item)
      if (key) quantities[key] = integer(item.quantity)
    })
    return quantities
  }

  function setCartSnapshot(cart) {
    state.cart = cart || null
    state.cartQuantities = cartQuantities(cart)
    state.cartSnapshotReady = true
  }

  function measure(name, data, options) {
    if (!state.consentAllowed || !state.measurementReady) return
    var cleaned = cleanContentsData(data)
    if (!cleaned) return
    if (
      (name === 'contents_viewed' || name === 'items_added' || name === 'checkout_started') &&
      (!cleaned.contents || cleaned.contents.length === 0)
    ) return
    if (options) window.oaiq('measure', name, cleaned, options)
    else window.oaiq('measure', name, cleaned)
  }

  function initializeUserData() {
    if (state.userInitialized) return
    var user = pixelUser()
    if (!user) return
    window.oaiq('init', { pixelId: config.pixelId, user: user })
    state.userInitialized = true
  }

  function sendInitialEvents() {
    if (!state.consentAllowed || state.initialEventsSent) return
    state.initialEventsSent = true

    measure('page_viewed', {
      type: 'contents',
      contents: [{ id: window.location.pathname || '/', name: config.pageTitle, content_type: 'page' }],
    })

    if (config.pageType === 'product' && config.product) {
      measure('contents_viewed', {
        type: 'contents',
        amount: integer(config.product.price),
        currency: config.currency,
        contents: [
          {
            id: text(config.product.variantId || config.product.sku),
            name: config.product.title,
            content_type: 'product',
            quantity: 1,
            amount: integer(config.product.price),
            currency: config.currency,
          },
        ],
      })
    }
  }

  function cookie(name) {
    var prefix = name + '='
    var parts = document.cookie ? document.cookie.split(';') : []
    for (var index = 0; index < parts.length; index += 1) {
      var part = parts[index].trim()
      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(part.slice(prefix.length))
        } catch (error) {
          return part.slice(prefix.length)
        }
      }
    }
    return ''
  }

  function validReference(value) {
    var candidate = text(value)
    if (!candidate || candidate.length > 2048 || /[\u0000-\u001f\u007f]/.test(candidate)) return ''
    return candidate
  }

  function validLandingPath(value) {
    var candidate = text(value)
    if (!candidate.startsWith('/') || candidate.startsWith('//')) return ''
    return candidate.slice(0, 512)
  }

  function currentOppref() {
    return state.ignoreLandingTouch ? '' : validReference(new URLSearchParams(window.location.search).get('oppref') || cookie('__oppref'))
  }

  function currentObref() {
    return state.ignoreLandingTouch ? '' : validReference(cookie('__obref'))
  }

  function clearReferenceCookies(names) {
    names.forEach(function (name) {
      ;['', '; Domain=' + window.location.hostname, '; Domain=chicchok.net', '; Domain=.chicchok.net'].forEach(function (domain) {
        document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure' + domain
      })
    })
  }

  function clearLandingReference() {
    if (window.history && typeof window.history.replaceState === 'function') {
      var cleanedUrl = new URL(window.location.href)
      if (!cleanedUrl.searchParams.has('oppref')) return
      cleanedUrl.searchParams.delete('oppref')
      window.history.replaceState(window.history.state, '', cleanedUrl.href)
    }
  }

  function cartRoute(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'
    return root + path
  }

  function updateCartAttributes(attributes) {
    return cartFetch(cartRoute('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_attribute_update_failed')
      return response.json()
    })
  }

  function syncAttributionToCart() {
    if (!state.consentAllowed) return Promise.resolve()
    if (state.attributionSync) return state.attributionSync

    var epoch = state.consentEpoch
    var operation = state.attributionClear.then(fetchCart)
      .then(function (cart) {
        if (!state.consentAllowed || epoch !== state.consentEpoch) return
        setCartSnapshot(cart)
        var existing = cart && cart.attributes ? cart.attributes : {}
        var attributes = attributionAttributes(existing)
        var signature = JSON.stringify(attributes)
        var alreadySynced = Object.keys(attributes).every(function (key) {
          return text(existing[key]) === attributes[key]
        })

        if (alreadySynced) {
          state.attributionSignature = signature
          return cart
        }

        return updateCartAttributes(attributes).then(function (updatedCart) {
          if (!state.consentAllowed || epoch !== state.consentEpoch) return
          state.attributionSignature = signature
          setCartSnapshot(updatedCart)
          return updatedCart
        })
      })
      .catch(function () {
        state.attributionSignature = ''
      })

    state.attributionSync = operation
    operation.finally(function () {
      if (state.attributionSync === operation) state.attributionSync = null
    })
    return operation
  }

  function clearAttributionFromCart() {
    try { window.localStorage.removeItem(attributionStorageKey) } catch (error) {}
    try { window.localStorage.removeItem('chicchok_openai_attribution_v2') } catch (error) {}
    // Remove both SDK matching cookies for this storefront, including domain cookies.
    clearReferenceCookies(['__oppref', '__obref'])
    if (state.ignoreLandingTouch) clearLandingReference()
    state.attributionSignature = ''
    var pending = state.attributionSync || state.attributionClear
    state.attributionSync = null
    state.cartSnapshotReady = false
    state.cart = null
    state.cartQuantities = {}
    state.recentAdds = {}
    state.attributionClear = pending.catch(function () {}).then(function () { return updateCartAttributes({
      openai_oppref: '',
      openai_obref: '',
      openai_landing_path: '',
      openai_measurement_consent: 'denied',
      openai_shop_domain: config.shopDomain,
      openai_consent_expires_at: '',
      openai_attribution_expires_at: '',
      openai_utm_source: '', openai_utm_medium: '', openai_utm_campaign: '',
      openai_utm_content: '', openai_utm_term: '',
    }) }).catch(function () {})
  }

  function fetchCart() {
    return cartFetch(cartRoute('cart.js'), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_fetch_failed')
      return response.json()
    })
  }

  function primeCartSnapshot() {
    if (state.cartSnapshotReady) return
    fetchCart().then(setCartSnapshot).catch(function () {})
  }

  function setConsent(allowed) {
    var next = Boolean(allowed)
    var changed = state.consentAllowed !== next
    if (changed) state.consentEpoch += 1
    state.consentAllowed = next
    if (!next || changed) {
      state.measurementReady = false
      window.oaiq('consent', false)
    }

    if (next) {
      state.consentCleared = false
      var epoch = state.consentEpoch
      var prepareMeasurement = function () {
        return syncAttributionToCart().then(function (cart) {
          if (!cart || !state.consentAllowed || epoch !== state.consentEpoch || state.measurementReady) return
          // Clean expired references before loading the SDK or enabling consent.
          // If cart read/write fails, remain disabled and retry; checkout is free
          // to proceed under the existing finite deadlines.
          if (typeof window.__CHICCHOK_NET_LOAD_OPENAI_SDK__ === 'function') window.__CHICCHOK_NET_LOAD_OPENAI_SDK__()
          state.measurementReady = true
          window.oaiq('consent', true)
          initializeUserData()
          sendInitialEvents()
        })
      }
      prepareMeasurement()
      window.setTimeout(prepareMeasurement, 1000)
      window.setTimeout(prepareMeasurement, 3000)
    } else if (changed || (!state.consentCleared && window.Shopify && window.Shopify.customerPrivacy)) {
      if (changed) state.ignoreLandingTouch = true
      state.consentCleared = true
      clearAttributionFromCart()
    }
  }

  function readShopifyConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy
    if (!privacy) return false

    // Shopify applies the visitor's region, merchant privacy settings, and any
    // explicit consent choice to this result. This also permits measurement in
    // regions where the banner is intentionally not shown.
    if (typeof privacy.marketingAllowed === 'function') {
      return privacy.marketingAllowed() === true
    }

    if (typeof privacy.currentVisitorConsent === 'function') {
      var visitorConsent = privacy.currentVisitorConsent()
      if (visitorConsent && (visitorConsent.marketing === 'yes' || visitorConsent.marketing === true)) {
        return true
      }
      if (visitorConsent && (visitorConsent.marketing === 'no' || visitorConsent.marketing === false)) {
        return false
      }
    }

    if (typeof privacy.getTrackingConsent === 'function') {
      return privacy.getTrackingConsent() === 'yes'
    }
    return false
  }

  function refreshConsent() {
    setConsent(readShopifyConsent())
  }

  function loadConsentApi() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return
    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1', onLoad: refreshConsent },
    ])
  }

  function recentDuplicate(key, quantity, source) {
    var recent = state.recentAdds[key]
    if (!recent || recent.source === source || Date.now() - recent.timestamp >= 3000) return 0
    return Math.min(quantity, integer(recent.quantity))
  }

  function sendAddedItem(variant, source) {
    if (!variant) return
    var key = variantKey(variant)
    var quantity = Math.max(1, integer(variant.quantity) || 1)
    var duplicateQuantity = key ? recentDuplicate(key, quantity, source) : 0
    var measuredQuantity = quantity - duplicateQuantity

    if (measuredQuantity > 0) {
      var added = Object.assign({}, variant, { quantity: measuredQuantity })
      var unitAmount = integer(variant.final_price == null ? variant.price : variant.final_price)
      measure('items_added', {
        type: 'contents',
        amount: unitAmount * measuredQuantity,
        currency: config.currency,
        contents: [cartItem(added)],
      })
    }

    if (key) {
      state.recentAdds[key] = { quantity: quantity, timestamp: Date.now(), source: source }
      if (source === 'variant' && state.cartSnapshotReady) {
        state.cartQuantities[key] = integer(state.cartQuantities[key]) + quantity
      }
    }
  }

  function sendCartQuantityIncreases(cart) {
    if (!state.consentAllowed || !cart || !Array.isArray(cart.items)) return
    var nextQuantities = cartQuantities(cart)
    if (!state.cartSnapshotReady) {
      state.cartQuantities = nextQuantities
      state.cartSnapshotReady = true
      return
    }

    cart.items.forEach(function (item) {
      var key = variantKey(item)
      if (!key) return
      var increase = integer(nextQuantities[key]) - integer(state.cartQuantities[key])
      if (increase > 0) sendAddedItem(Object.assign({}, item, { quantity: increase }), 'cart')
    })

    state.cartQuantities = nextQuantities
    Object.keys(state.recentAdds).forEach(function (key) {
      if (Date.now() - state.recentAdds[key].timestamp >= 3000) delete state.recentAdds[key]
    })
  }

  function productCheckoutData() {
    if (!config.product) return { type: 'contents' }
    return {
      type: 'contents',
      amount: integer(config.product.price),
      currency: config.currency,
      contents: [
        {
          id: text(config.product.variantId || config.product.sku),
          name: config.product.title,
          content_type: 'product',
          quantity: 1,
          amount: integer(config.product.price),
          currency: config.currency,
        },
      ],
    }
  }

  function checkoutData(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return productCheckoutData()
    return {
      type: 'contents',
      amount: integer(cart.total_price),
      currency: cart.currency || config.currency,
      contents: cart.items.slice(0, 100).map(cartItem),
    }
  }

  function prepareCheckout() {
    if (!state.consentAllowed) {
      // Revocation may still be clearing an earlier granted cart marker.
      return new Promise(function (resolve) {
        var timer = window.setTimeout(resolve, 3800)
        state.attributionClear.finally(function () { window.clearTimeout(timer); resolve() })
      })
    }
    if (state.checkoutPending) return state.checkoutPending
    // A pending page-load sync may contain a snapshot from before the latest add.
    var work = Promise.resolve(state.attributionSync).then(syncAttributionToCart).then(function (cart) {
      if (!state.consentAllowed || state.checkoutSent || !cart || !cart.items || !cart.items.length) return
      state.checkoutSent = true
      measure('checkout_started', checkoutData(cart))
    }).catch(function () {})
    state.checkoutPending = new Promise(function (resolve) {
      var timer = window.setTimeout(resolve, 1800)
      work.finally(function () { window.clearTimeout(timer); resolve() })
    }).finally(function () { state.checkoutPending = null })
    return state.checkoutPending
  }

  function isCartAdd(url, method) {
    try {
      var parsed = new URL(url, window.location.href)
      return String(method || 'GET').toUpperCase() === 'POST' && parsed.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname)
    } catch (error) { return false }
  }

  function addedQuantities(body) {
    var payload = body
    if (typeof body === 'string') {
      try { payload = JSON.parse(body) }
      catch (error) { payload = new URLSearchParams(body) }
    }
    var items = []
    if (payload && typeof payload.get === 'function') {
      if (payload.get('id')) items.push({ id: payload.get('id'), quantity: payload.get('quantity') || 1 })
      else {
        var indexed = {}
        payload.forEach(function (value, key) {
          var match = key.match(/^items\[(\d+)\](?:\[(id|quantity)\]|(id|quantity))$/)
          if (match) {
            indexed[match[1]] = indexed[match[1]] || {}
            indexed[match[1]][match[2] || match[3]] = value
          }
        })
        items = Object.values(indexed)
      }
    } else if (payload) { items = Array.isArray(payload.items) ? payload.items : [payload] }
    var quantities = {}
    items.forEach(function (item) {
      var id = text(item.id)
      var count = Number(item.quantity == null ? 1 : item.quantity)
      if (id && Number.isInteger(count) && count > 0) quantities[id] = (quantities[id] || 0) + count
    })
    return quantities
  }

  function recordSuccessfulAdd(payload, quantities, epoch) {
    if (!state.consentAllowed || epoch !== state.consentEpoch) return
    var emitted = {}
    ;(Array.isArray(payload.items) ? payload.items : [payload]).forEach(function (item) {
      var id = text(item.variant_id || item.id)
      if (emitted[id] || !quantities[id]) return
      emitted[id] = true
      sendAddedItem(Object.assign({}, item, { quantity: quantities[id] }), 'request')
    })
    state.cartSnapshotReady = false
  }

  // Observe successful cart adds regardless of which theme/app owns the UI.
  // Record before returning the response, so a redirect cannot skip the event.
  var originalFetch = window.fetch
  window.fetch = function (input, options) {
    var url = typeof input === 'string' || input instanceof URL ? String(input) : input.url
    var method = (options && options.method) || (input && input.method) || 'GET'
    if (!isCartAdd(url, method) || !state.consentAllowed) return originalFetch.apply(this, arguments)
    var epoch = state.consentEpoch
    var body = options && options.body
    var requestBody = Promise.resolve(body)
    if (body == null && input instanceof Request) requestBody = input.clone().text().catch(function () { return null })
    return originalFetch.apply(this, arguments).then(function (response) {
      if (!response.ok) return response
      return Promise.all([response.clone().json(), requestBody]).then(function (values) {
        recordSuccessfulAdd(values[0], addedQuantities(values[1]), epoch)
      }).catch(function () {}).then(function () { return response })
    })
  }

  var originalOpen = XMLHttpRequest.prototype.open
  var originalSend = XMLHttpRequest.prototype.send
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__chicchokCartAdd = isCartAdd(url, method)
    return originalOpen.apply(this, arguments)
  }
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__chicchokCartAdd && state.consentAllowed) {
      var epoch = state.consentEpoch
      var quantities = addedQuantities(body)
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return
        try {
          recordSuccessfulAdd(this.responseType === 'json' ? this.response : JSON.parse(this.responseText), quantities, epoch)
        } catch (error) {}
      }, { once: true })
    }
    return originalSend.apply(this, arguments)
  }

  // Existing buy-now callers retain this interface. The request observer above
  // is now the sole add-event producer, avoiding theme/app double counting.
  window.CHICCHOK_OPENAI_TRACKING = {
    prepareCheckout: prepareCheckout,
    added: function () {},
  }

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) setCartSnapshot(event.detail.cart)
  })

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest(
            'a[href*="/checkout"]'
          )
        : null
      if (target && !event.defaultPrevented && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0 && !target.target) {
        var destination = new URL(target.href, window.location.href)
        if (destination.origin === window.location.origin && /\/checkout(?:\/|$)/.test(destination.pathname)) {
          event.preventDefault()
          prepareCheckout().finally(function () { window.location.assign(destination.href) })
        }
      }

      var consentAction = event.target && event.target.closest
        ? event.target.closest('[data-action~="accept-policy"], [data-action~="decline-policy"]')
        : null
      if (consentAction) {
        window.setTimeout(refreshConsent, 150)
        window.setTimeout(refreshConsent, 500)
      }
    },
    true
  )

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target
      var submitter = event.submitter
      if (form && form.dataset && form.dataset.openaiCheckoutResume === 'true') return
      var action
      try { action = new URL(form && form.action || '', window.location.href) } catch (error) {}
      if (form && action && action.origin === window.location.origin && /\/cart\/?$/.test(action.pathname) && submitter && submitter.name === 'checkout' && !event.defaultPrevented) {
        event.preventDefault()
        prepareCheckout().finally(function () {
          form.dataset.openaiCheckoutResume = 'true'
          try { form.requestSubmit(submitter) }
          finally { delete form.dataset.openaiCheckoutResume }
        })
      }
    },
    true
  )

  document.addEventListener('visitorConsentCollected', refreshConsent)
  // Native wallets retain their trusted user gesture. Pre-sync but do not
  // claim checkout_started merely because a payment button was pressed.
  document.addEventListener('pointerdown', function (event) {
    if (event.target && event.target.closest && event.target.closest('.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]')) {
      syncAttributionToCart()
    }
  }, true)
  window.addEventListener('focus', refreshConsent)
  window.addEventListener('pageshow', function () { state.checkoutSent = false; refreshConsent() })

  loadConsentApi()
  refreshConsent()
})()
